module.exports = __webpack_public_path__ + "img/bb.jpg";